<!-- notification-modal.component.html -->
@if (showModal) {
<div
  class="orgApp-nmodal-overlay"
  (keydown)="($event.key === 'Enter' || $event.key === ' ') && closeModal()"
  (click)="closeModal()"
></div>
} @if (showModal) {
<div class="orgApp-nmodal-container">
  <div
    class="orgApp-nmodal-content"
    (click)="$event.stopPropagation()"
    (keydown)="
      ($event.key === 'Enter' || $event.key === ' ') && $event.stopPropagation()
    "
  >
    <div class="orgApp-landing-page-notification-main-container">
      <div
        class="orgApp-nmodal-header orgApp-d-flex orgApp-justify-c-spc-btw orgApp-gap-16 orgApp-align-i-center"
      >
        <h2 class="orgApp-nmodal-title orgApp-font-graphik">
          {{ "toolbar.content.notificationDialog.title" | translate }}
        </h2>
      </div>
      <div
        class="orgApp-nmodal-not-content orgApp-font-graphik"
      >
        <div
        
        >
          @if (loading) {
          <div>
            @for (item of [1, 2, 3, 4]; track $index) {
            <div class="orgApp-d-flex orgApp-gap-16 orgApp-nmodal-skel-item">
              <ngx-skeleton-loader
                appearance="circle"
                class="orgApp-nmodal-img-loader"
              ></ngx-skeleton-loader>
              <ngx-skeleton-loader
                count="2"
                class="orgApp-nmodal-text-loader"
              ></ngx-skeleton-loader>
            </div>
            }
          </div>
          } @if (!loading) { @if(filteredNotifications.length > 0){
          <div>
            @for (notification of filteredNotifications; track notification) {
            <div
              class="orgApp-nmodal-not-item"
              (click)="openNotificationDetail(notification)"
              (keydown)="
                ($event.key === 'Enter' || $event.key === ' ') &&
                  openNotificationDetail(notification)
              "
            >
              <div class="orgApp-nmodal-item orgApp-gap-16 orgApp-d-flex">
                @if (['SWAP_DUTY_APPROVE', 'SWAP_DUTY_APPROVED', 'SWAP_DUTY_DECLINED', 'SWAP_DUTY_REJECTED', 'SWAP_DUTY_CANCELLED'].includes(notification.type)) {
                 <div class="orgApp-nmodal-swap-img-div">
                 <img
                   [src]="notification.swapTransfUserImage"
                   class="orgApp-nmodal-i-img orgaApp-nmodal-img-s"
                   alt="Avatar"
                 />
                 <img
                   [src]="notification.swapInitUserImage"
                   class="orgApp-nmodal-i-img orgApp-nmodal-top-img orgaApp-nmodal-img-xs"
                   alt="Avatar"
                 />
               </div>
                }
               @else{
                <img
                  [src]="notification?.type === 'SWAP_DUTY_REQUEST' ? notification?.swapAvatar : notification?.avatar"
                  class="orgApp-nmodal-i-img orgaApp-nmodal-img-m"
                  alt="Avatar"
                />
              }
                <div
                  class="orgApp-nmodal-text orgApp-d-flex orgApp-gap-8 orgApp-flex-dir-col"
                >
                  <p class="orgApp-nmodal-i-title">
                    {{ notification.message }}
                  </p>
                  <p class="orgApp-nmodal-i-time">{{ notification.time }}</p>
                </div>
              </div>
              @if (notification.status ==='UNREAD') {
              <div class="orgApp-nmodal-unread-div"></div>
              }
            </div>
            }
          </div>
          } @else{
          <p class="orgApp-no-notifications-text">
            {{ "usernotification.detail.label.no-new-notifications" | translate }}
          </p>
          } }
        </div>
      </div>
      <div mat-dialog-actions class="orgApp-landing-page-notification-footer">
        <button
          mat-button
          (click)="viewAllNotifications()"
          class="orgApp-nmodal-footer-text orgApp-font-graphik"
        >
          {{ "toolbar.content.notificationDialog.action.view_all" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
}
